export default __webpack_public_path__ + "images/home-icon-white.27837836f2bcfa0a80b99902f5d7acce.png";